<template>
	<div class="editor">
		<div class="config">
			<span>Create filter</span>
			&nbsp;
			<el-input
				v-model="value.name"
				placeholder="Filter name"
				style="width:300px">
			</el-input>
			&nbsp;
			<span>for patients</span>
			&nbsp;
			<el-select
				v-model="value.param"
				placeholder="select time period"
				@change="changed"
				style="width:175px">
				<el-option value="date" label="in a date range"></el-option>
				<el-option value="all" label="over all time"></el-option>
				<el-option value="last" label="in the last"></el-option>
			</el-select>
			&nbsp;
			<span v-show="value.param == 'last'">
				<el-input style="width:60px" v-model="value.last">
				</el-input>
				&nbsp;
				<span> days </span>
			</span>
			<span>where</span>
		</div>

		<Expression
			v-model="value.predicate"
			@change="changed"
		></Expression>

		<div class="action">
			<el-button type="primary" @click="save"
				v-bind:disabled="editingFilter">
				<strong>Save Filter</strong>
			</el-button>
			<el-button plain @click="clear">
				<strong>Clear Conditions</strong>
			</el-button>
		</div>
	</div>

</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import Expression from './Expression'
import formatCount from '@/module/util/format-count'

export default {
	name: 'filter-editor',

	props: ['value'],

	mounted() {

	},

	data() {
		return {
			name: this.value ? this.value.name : '',
			param: this.value ? this.value.param : 'date',
			last: this.value ? this.value.last : 30
		}
	},

	methods: {
		clear() {
			if (this.value.predicate.term.length > 0)
				this.$confirm('This will permanently delete <strong>' +
					formatCount(this.value.predicate.term.length, 'condition') + '</strong> from this filter.',
					'Are you sure?', {
						confirmButtonText: 'Delete conditions',
						cancelButtonText: 'Cancel',
						confirmButtonClass: 'el-button--danger',
						dangerouslyUseHTMLString: true
			        })
				.then(() => {
					Vue.set(this.value, 'predicate', {
						id: ['logic', 'and'],
						term: []
					})
		        })
		},
		changed() {
			if (this.value.param === 'last' && this.value.last == null)
				Vue.set(this.value, 'last', 30)

			this.$emit('value', this.value)
			this.$emit('change')
		},
		save() {
			if (! this.editingFilter)
				this.$emit('save', this.value)
		}
	},

	computed: {
		...mapState('provider', ['editingFilter'])
	},

	components: {
		Expression
	}
}
</script>

<style lang="scss" scoped>
.editor {
	padding: 10px;

	.config {
		margin-bottom: 20px;
		line-height: 50px;

		span {
			color: #355170;
			font-weight: 700;
		}
	}
	.action {
		padding-top: 15px;
		// text-align: right;
	}
}
</style>
